/**
 * 用于自定义枚举下拉数据等
 */
class Enum {
  handlers = [];

  immutableData = [];

  keys = [];

  values = [];

  labels = [];

  setItem(key, value, desc) {
    this.immutableData[key] = value;

    this[key] = value;
    this.keys.push(key);
    this[`${key}_LABEL`] = desc;
    this[value] = desc;
    this.values.push(value);
    this.labels.push(desc);

    return this;
  }

  addHandler(fn, ...args) {
    const fns = this.handlers.map(([fn]) => fn) || [];
    if (!fn || typeof fn !== 'function' || fns.includes(fn)) return this;

    this.handlers.push([fn, args]);
    return this;
  }

  get OPTIONS() {
    return Object.entries(this.immutableData || {}).map(([key, value]) => {
      const initData = { key, label: this[value], value };
      return this.handlers.reduce((prev, [fn, args]) => fn(prev, ...args), initData);
    });
  }
}

/**
 * 使用
 */
// const TEST = new Enum();
// TEST.addItem('VISIBLE', '1', '可见').addItem('UN_VISIBLE', '0', '不可见');
// TEST.keys // ['VISIBLE', 'UN_VISIBLE']
// TEST.values // ['1', '0']
// TEST.labels // ['可见', '不可见']
// TEST.VISIBLE // 1
// TEST[1] // 可见
// TEST.VISIBLE_LABEL // 可见
// TEST.OPTIONS // [{ key: 'VISIBLE', label: '可见', value: '1' }, { key: 'UN_VISIBLE', label: '不可见', value: '0' }]

export default Enum;


// WEBPACK FOOTER //
// ./src/utils/Enum.js